import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Avatar, Box, Button, Card, Chip, Container, Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toTitleCase, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import http from "../../../commonFunctions/httpClient";
import WSAutocompleteField from "../../../Components/AutoComplete/AutoComplete";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import config from '../../../Config/config.json';
import { useSnackbar } from '../../../Components/Snackbar/SnackBarContext';
export const DoctorSearchBooking: React.FC<any> = React.memo((props) => {
    const { control, } = useForm();
    const [doctorList, setDoctorList] = useState<any>([])
    const [specializationId, setSpecializationId] = useState(null);
    // Removed customer selection from this page
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { showMessage } = useSnackbar();
    useEffect(() => {
        updateMainHeader("Book a Doctor");
    });

    breadCrumbsStore.updateBreadCrumbs([{ "Booking List": "/booking/list" }, { "Book": "" }]);
    const navigate = useNavigate();
    const source = {
        url: "Specialization/search",
        page: 1,
        pageSize: 10000000000,
        filter: [],
        sort: [],
    };
    // Customer source removed; customer will be selected on the slot booking page

   useEffect(() => {
  async function getSpecialisation() {
    try {
      setIsLoading(true);

      // Prepare body based on specializationId
      const body = specializationId
        ? { specializationIds: [specializationId] }
        : {};

      const response: any = await http.post(`Searchontroller/search`, body);

      if (response?.success === false) {
        showMessage(response?.message, 'error');
      }

      setDoctorList(response?.data ?? []);
    } catch (err) {
      setDoctorList([]);
    } finally {
      setIsLoading(false);
    }
  }

  // Always load doctors (filtered or all)
  getSpecialisation();
}, [specializationId]);

    const handleBookButtonClick = (data: any) => {
        navigate(`/booking/list/book/add/id/${data?.userId}/profile/${data?.id}`, { state: { fees: data?.fees, doctor: data } });
    }
    const renderDoctorCard = (doctor: any) => (
        <Card
            key={doctor.id}
            sx={{
                position: "relative",
                p: 2.5,
                mb: 3,
                borderRadius: 3,
                minHeight: 240, // ensures consistent height
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                bgcolor: "background.paper",
                boxShadow:
                    "0px 8px 24px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.04)",
                transition: "all 0.3s ease",
                "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0px 12px 30px rgba(0,0,0,0.12)",
                },
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "5px",
                    background:
                        "linear-gradient(90deg, #098963 0%, #32b67a 50%, #098963 100%)",
                },
            }}
        >
            <Grid container spacing={2.5} alignItems="flex-start" sx={{ flexGrow: 1 }}>
                {/* Image */}
                <Grid item xs={12} sm={4} md={3}>
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <Avatar
                            alt={doctor?.user?.name}
                            src={
                                doctor?.profileImageUrl
                                    ? config.imgUrl + doctor.profileImageUrl.replace("UploadedImages/", "")
                                    : undefined
                            }
                            sx={{
                                width: 90,
                                height: 90,
                                border: "3px solid #e0f2f1",
                                bgcolor: "grey.100",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }}
                        >
                            {!doctor?.profileImageUrl && (
                                <PersonIcon sx={{ fontSize: 50, color: "#098963" }} />
                            )}
                        </Avatar>
                    </Box>
                </Grid>

                {/* Details */}
                <Grid item xs={12} sm={8} md={9} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <Stack spacing={1} sx={{ flexGrow: 1 }}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Box>
                                <Typography

                                    sx={{ fontWeight: 700, color: "text.primary", fontSize: "0.95rem" }}
                                >
                                    {doctor?.user?.name && toTitleCase(doctor?.user?.name)}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem", color: "text.secondary", paddingLeft: 1 }}>
                                    {doctor?.qualifications?.map((q: any) => q.name).join(", ") || "-"}
                                </Typography>
                                <Typography sx={{ fontSize: "0.75rem", color: "text.secondary", paddingLeft: 1 }}>
                                    {doctor?.specializations?.map((s: any) => s.specializations).join(", ") || "-"}
                                </Typography>



                            </Box>

                            <Chip
                                size="small"
                                color="success"
                                icon={<CurrencyRupeeIcon sx={{ fontSize: "0.75rem" }} />}
                                label={`${doctor?.fees ?? 0}`}
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "0.8rem",
                                    px: 0.5,
                                    bgcolor: "#e8f5e9",
                                    color: "#098963",
                                }}
                            />
                        </Stack>

                        <Stack
                            direction="row"
                            flexWrap="wrap"
                            spacing={1}
                            useFlexGap
                            sx={{ mt: 1 }}
                        >

                            <Chip
                                size="small"
                                variant="outlined"
                                icon={<WorkOutlineIcon sx={{ fontSize: "0.75rem" }} />}
                                label={`${doctor.experience || 0} yrs`}
                            />


                            {!!doctor?.reviewsCount && (
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    icon={
                                        <StarRateRoundedIcon
                                            sx={{ fontSize: "0.9rem", color: "#f5b301" }}
                                        />
                                    }
                                    label={`${doctor.reviewsCount}+ reviews`}
                                />
                            )}

                            {(doctor?.languages || []).slice(0, 3).map((lang: string) => (
                                <Chip
                                    key={lang}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        borderColor: "#e0f2f1",
                                        bgcolor: "#f9fdfa",
                                        fontSize: "0.75rem",
                                    }}
                                    label={lang}
                                />
                            ))}
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                            <LocationOnIcon sx={{ fontSize: "1rem", color: "#098963" }} />
                            <Typography variant="body2" color="text.secondary">
                                {doctor?.city || doctor?.location || "—"}
                            </Typography>
                        </Stack>
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    {/* Button fixed at bottom */}
                    <Box display="flex" justifyContent="flex-end" mt="auto">
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleBookButtonClick(doctor)}
                            sx={{
                                textTransform: "none",
                                borderRadius: "20px",
                                px: 3,
                                py: 0.5,
                                fontWeight: 600,
                                background: "linear-gradient(90deg,#098963,#32b67a)",
                                boxShadow: "0 3px 8px rgba(9,137,99,0.3)",
                                "&:hover": {
                                    background: "linear-gradient(90deg,#077c55,#26a86a)",
                                    boxShadow: "0 5px 12px rgba(9,137,99,0.4)",
                                },
                            }}
                        >
                            Book Now
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );




    const transformSpecialization = (data: any) => {
        const specilazationList: Array<any> = [];
        if (data) {

            data?.map((item: any) => {
                specilazationList.push({ label: item?.specializations, value: item?.id })
            })
        }
        return specilazationList;
    }
    // Removed customer transform; not needed here
    const handleSpecilisationChange = (evt: any, value: any) => {
        const spezId = value?.value;
        setSpecializationId(spezId)
    }
    // Removed customer change handler
    return (<>
        <Container maxWidth="lg" sx={{ py: 3 }}>
            <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
                <form>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={12}>
                            <WSAutocompleteField id="auto-search-specialization" control={control} label={'Specialization'} name="specialization" source={source} onChange={handleSpecilisationChange} transFormData={transformSpecialization} />
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Box sx={{ mt: 3 }}>
                {isLoading ? (
                    <Grid container spacing={3}>
                        {[1, 2, 3].map((i) => (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                <Card sx={{ p: 2, borderRadius: 2 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3} md={2}>
                                            <Skeleton variant="circular" width={64} height={64} />
                                        </Grid>
                                        <Grid item xs={9} md={10}>
                                            <Skeleton variant="text" width="40%" height={28} />
                                            <Skeleton variant="text" width="60%" />
                                            <Skeleton variant="rectangular" height={28} sx={{ mt: 1, borderRadius: 1 }} />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : doctorList.length > 0 ? (
                    <Grid container spacing={3}>
                        {doctorList.map((doc: any) => (
                            <Grid item xs={12} sm={6} md={4} key={doc.id}>
                                {renderDoctorCard(doc)}
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
                        <Typography variant="h6" fontWeight={700} gutterBottom>
                            No doctors found
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Try choosing a different specialization or check back later.
                        </Typography>
                    </Paper>
                )}
            </Box>
        </Container>

    </>)
})